import type { ContactInfo } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const useContactInfo = (
  options?: UseQueryOptions<ContactInfo, unknown, ContactInfo>,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useQuery({
    enabled: Boolean(selectedOrganization.rendallURL), // TODO AWN-217933
    queryFn: () => api.getContactInfo(),
    queryKey: ['rendall', 'get-contact-info'],
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};
